import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import org.w3c.dom.HTMLDialogElement
import org.w3c.dom.events.Event

@JsExport
@StimulusController(targets = ["linkDialog", "fileDialog"])
class AttachmentDialogController(context: dynamic) : Controller(context) {
    val linkDialog by linkDialogTarget<HTMLDialogElement>()
    val fileDialog by fileDialogTarget<HTMLDialogElement>()

    @JsName("openLink")
    fun openLink(event: Event) {
        event.preventDefault()
        linkDialog.showModal()
    }

    @JsName("openFile")
    fun openFile(event: Event) {
        event.preventDefault()
        fileDialog.showModal()
    }

    override fun connect() {
        arrayOf(linkDialog, fileDialog).forEach { dialog ->
            dialog.addEventListener("click", { event ->
                if (event.target == dialog) dialog.close()
            })
        }
    }
}
